export const API_PATH_ApiDeviceMgmtSettingsGet = '/services/devices-mgtm/apiDeviceMgmtSettingsGet';
